module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 1.e95c3ff9.png";